/**
 * Parses a firmware name to its components
 */
export function parseDFUName(name) {
    const split = name.split("_");
    return {
        project: split[0],
        version: split[1],
        hardware: split[2],
        customer_id: split[3],
    };
}
//# sourceMappingURL=firmware-utils.js.map